import styled from 'styled-components';

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  & button {
    width: 16.875rem;
    margin-left: 1.5rem;
  }
`;
